import party from 'party-js';

export const shootConfetti = (sourceElementId: string) => {
  const confettiSettings = {
    shapes: [
      'square',
      'rectangle',
      'roundedSquare',
      'circle',
      'roundedRectangle',
      'logo',
    ],
    // The amount of confetti particles that should be emitted.
    count: party.variation.range(125, 125),
    // The amount of spread that is applied to the emission angle. Note that the default angle points upwards.
    spread: 135,
    // The initial speed that the confetti particles are emitted with.
    speed: party.variation.range(500, 700),
    // The initial size that the confetti particles are emitted with.
    size: party.variation.skew(1, 0.7),
    // The initial rotation that the confetti particles are emitted with.
    rotation: () => party.random.randomUnitVector().scale(135),
    // The initial color that particles are emitted with.
    color: () =>
      party.random.pick([
        party.Color.fromHex('#C80E04'),
        party.Color.fromHex('#08172B'),
        party.Color.fromHex('#213845'),
        party.Color.fromHex('#008055'),
        party.Color.fromHex('#C80E04'),
        party.Color.fromHex('#102F56'),
        party.Color.fromHex('#437089'),
        party.Color.fromHex('#FB4137'),
        party.Color.fromHex('#205EAC'),
        party.Color.fromHex('#76A3BC'),
        party.Color.fromHex('#FFBF00'),
        party.Color.fromHex('#00B278'),
        party.Color.fromHex('#FED0CD'),
        party.Color.fromHex('#FB4137'),
        party.Color.fromHex('#DDE8EE'),
      ]),
  };

  // Toggle this to see fps
  //   party.settings.debug = true;

  party.settings.gravity = 400;
  party.settings.zIndex = -1;

  // Iwoca logo shape
  party.resolvableShapes['logo'] =
    `<img src="https://public-uk-static.iwoca.com/icons-9a8253bee6246c87b02c46d8ee6dccd4/favicon-16x16.png"/>`;

  // Where it will emit from
  const confettiSource = document.getElementById(sourceElementId);
  if (confettiSource) {
    party.confetti(confettiSource as HTMLElement, confettiSettings);
  }
};
